<template>
  <div v-if="inital">

    <notifications />
    <div v-if="user" :class="{ 'nav-open': $sidebar.showSidebar }">
        <template v-for="(card, key) in $route.query">
          <component
            :key="key"
            :is="key"
            :style="{
              zIndex: priority[key] ? priority[key] : 10,
            }"
            v-if="items[key]"
            :id="card"
          />
        </template>
      
        <router-view  />
    </div>
    <div v-else>
      <auth />
    </div>


  </div>
</template>

<script>
import Auth from "@/pages/Auth";
import { mapState } from "vuex";

export default {
  data: () => ({
    inital: false,
    audio: null,
    priority: {},
    isCard: false,
  }),
  components: {
    Auth,
  },
  computed: {
    ...mapState(["user", "modalName", "items", "lastMessage"]),
  },
  methods: {
   
   },

  created() {
     this.$loading(true);
     this.$http.get('storages').then((response) => {
          this.$store.dispatch("setLanguages", response.data.data.languages);
          this.$store.dispatch("setLocations", response.data.data.locations);
          this.$http
            .get("profile")
            .then((response) => {
              // TEMP
              response.data.routes = response.data.routes.filter(e=>{
                // imports navigations texts roles
                return !["imports", "texts", "navigations", "roles"].some(text=>{
                  return text == e.code
                })
              })
              // TEMP END
              this.$store.dispatch("setUser", response.data);
              this.$store.dispatch("setStats", response.data.stats);
              this.$store.dispatch("setRoutes", response.data.routes);
            })
            .catch((error) => {
              this.$store.dispatch("setUser", null);
            })
            .finally(() => {
              this.inital = true;
                setTimeout(() => {
                  this.$loading(false);
                }, 400);
            });
     }).catch((error) => {
        console.log(error);
        alert('Ошибка инницилизации проекта, пожалуйста обновите страницу.')
     });
  },
  watch: {
    modalName(val) {
      if (val) {
        setTimeout(() => {
          this.$modal.show(val.model);
        }, 10);
      }
    },
    "$route.query": {
      handler: function (val) {
        let k = 1;
        let isOpened = false;
        for (var key in val) {
          if (this.items[key]) {
            isOpened = true;
          }
          k++;
          this.priority[key] = 3 + k;
        }
        if (isOpened === true) {
            document.documentElement.style.overflowY = 'hidden';
        } else {
               document.documentElement.style.overflowY = 'scroll';
        }
        this.isCard = isOpened;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style>
  .notifications {
    z-index:999999;
  }
</style>

